import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import isEmpty from 'lodash/isEmpty';
import Fuse from "fuse.js";
import {toast} from "../../../store/toaster/actions";
import styled from "styled-components";
import {getMileageRates} from "./store/actions";
import {InputGroup, NonIdealState, Spinner, Button} from "@blueprintjs/core";
import {AutoSizer, Column, Table} from "react-virtualized";
import Editor from "./editor";
import {toggleMileageRateEditor} from './store/actions';


const StyledList = styled.div`
  height: 100%;
  width: 100%;
  padding: 8px 16px;
`;

const FUSE_OPTIONS = {
  threshold: 0.5,
  maxPatternLength: 32,
  minMatchCharLength: 2,
  keys: [
    {name: 'name', weight: 0.4},
  ]
};

class SettingsMileageRates extends Component {
  state = {
    search: '',
    record: parseInt(this.props.match.params._id),
  }

  componentDidMount() {
    this.props.getMileageRates();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (!isEmpty(nextProps.data)) {
      nextProps.getMileageRates();
    }
  }

  render() {
    const { records, loading, toggleMileageRateEditor } = this.props;
    const fuse = new Fuse(records, FUSE_OPTIONS);
    const filteredRecords = this.state.search.length ? fuse.search(this.state.search) : records;


    return (
      <React.Fragment>
        {loading ? (
          <Spinner className="mt50" />
        ) : (
          <React.Fragment>
            <div className="tools">
              <Button large onClick={() => toggleMileageRateEditor({})} icon="add" intent="success" text="Add New" />
              <div className="flex">
                <InputGroup
                  leftIcon="search"
                  onChange={(e) => {
                    this.setState({
                      search: e.currentTarget.value
                    })
                  }}
                  large
                  placeholder="Search"
                />
              </div>
            </div>
            {filteredRecords.length > 0 ? (
              <StyledList>
                <AutoSizer>
                  {({width, height}) => (
                    <Table
                      ref="Table"
                      headerHeight={30}
                      noRowsRenderer={this._noRowsRenderer}
                      overscanRowCount={10}
                      rowClassName={this._rowClassName}
                      rowHeight={30}
                      rowCount={filteredRecords.length}
                      rowGetter={({ index }) => filteredRecords[index]}
                      height={height}
                      onRowClick={(event) => toggleMileageRateEditor(event.rowData)}
                      width={width}>
                      <Column
                        label='Name'
                        dataKey='name'
                        width={width * 0.2}
                      />
                      <Column
                        label='Band1Rate'
                        dataKey='band1rate'
                        width={width * 0.1}
                      />
                      <Column
                        label='Band1Limit'
                        dataKey='band1limit'
                        width={width * 0.1}
                      />                      
                      <Column
                        label='Band2Rate'
                        dataKey='band2rate'
                        width={width * 0.1}
                      />                      
                      <Column
                        label='Band2Limit'
                        dataKey='band2limit'
                        width={width * 0.1}
                      />                      
                      <Column
                        label='Band3Rate'
                        dataKey='band3rate'
                        width={width * 0.1}
                      />                      
                      <Column
                        label='Band3Limit'
                        dataKey='band3limit'
                        width={width * 0.1}
                      />                      
                      <Column
                        label='Band4Rate'
                        dataKey='band4rate'
                        width={width * 0.1}
                      />                      
                      <Column
                        label='Band4Limit'
                        dataKey='band4limit'
                        width={width * 0.1}
                      />                      
                    </Table>
                  )}
                </AutoSizer>
              </StyledList>
            ) : (
              <NonIdealState
                icon="search"
                title="No mileage rate found"
              />
            )}
          </React.Fragment>
        )}
        <Editor />
      </React.Fragment>
    );
  }
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({
    toast,
    getMileageRates,
    toggleMileageRateEditor,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    loading: state.settingsMileageRates.loading,
    records: state.settingsMileageRates.data,
  }
}

export default (connect(mapStateToProps, matchDispatchToProps)(SettingsMileageRates));
